import { FIND_ROUTE_PATHS } from './find/config';
import { KYC_ROUTE_PATHS } from './kyc/config';
import { USERS_OPERATIONS_ROUTE_PATHS } from '@modules/users-operations/config';
import { COMMUNICATIONS_ROUTE_PATHS } from './communications/config';
import { TP_ACCOUNTS_ROUTE_PATHS } from './tp-accounts/config';
import { FACE_MATCH_PROVIDER_ROUTE_PATHS } from './face-match-provider/config';

export const USERS_ROUTE_PATHS = { ...FIND_ROUTE_PATHS, ...KYC_ROUTE_PATHS, ...USERS_OPERATIONS_ROUTE_PATHS, ...COMMUNICATIONS_ROUTE_PATHS, ...TP_ACCOUNTS_ROUTE_PATHS, ...FACE_MATCH_PROVIDER_ROUTE_PATHS };

export default { RoutePaths: USERS_ROUTE_PATHS };
